module.exports = __webpack_public_path__ + "img/logo.2bb6c9db.png";